// @ts-nocheck

import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useEffect } from 'react';
import { appendSrcScript } from '@shared/utils/general';
import { isBHZainSLA, isMAUmobileSLA } from '@entities/operator/model/utils';
import { isBH, isMY } from '@entities/country';

/* global Detector */

export const useSLAOperators = () => {
  const { homeData, subscribeData, operator } = useAtomValue(dcbAtom);

  const isBHZainSLAOperator =
    isBH(homeData?.country) && isBHZainSLA(subscribeData?.operatorName || operator?.value);
  const isMAUmobileOperator =
    isMY(homeData?.country) && isMAUmobileSLA(subscribeData?.operatorName || operator?.value);

  const isSLA = isBHZainSLAOperator || isMAUmobileOperator;

  const antifraudScript = subscribeData?.antifraudScript || null;

  const handleInjectScript = () => {
    const onLoad = () => {
      const ids = {
        form: 'otp-pin-form',
        confirm_button: 'submit-otp',
        cancel_button: 'cancel-otp',
        pin_input: 'pin-input-full',
      };

      const partner = subscribeData?.apiSubscribeCustomerID || '';
      const service = subscribeData?.apiSubscribeServiceID || '';
      const fraudToken = null;

      const detector = new Detector(ids, partner, service, fraudToken, {});

      detector.setup();
    };

    appendSrcScript(antifraudScript, onLoad);
  };

  useEffect(() => {
    if (!isSLA || !antifraudScript) return;

    handleInjectScript();
  }, [isSLA, antifraudScript]);

  return {
    isBHZainSLAOperator,
    isMAUmobileOperator,
  };
};
